<p-table #pt
         fqTableHostInjector
         [value]="tableData"
         [responsiveLayout]="responsiveLayout"
         [globalFilterFields]="computedGlobalFilterFields"
         [styleClass]="tableStyleClass"
         [style.--fq-row-height]="virtualRowHeight"
         [size]="size"
          [scrollable]="scrollable"
          [scrollHeight]="scrollHeight"
          [virtualScroll]="virtualScroll"
          [virtualScrollItemSize]="effectiveVirtualScrollItemSize"
          [loading]="loading"
          [showLoader]="false"
         [stripedRows]="stripedRows"
         [rowHover]="rowHover"
         [showGridlines]="showGridlines"
         [dataKey]="dataKey || null"
         [paginator]="paginator"
         [rows]="rows"
         [rowsPerPageOptions]="rowsPerPageOptions"
         [paginatorPosition]="paginatorPosition"
         [alwaysShowPaginator]="alwaysShowPaginator"
         [showJumpToPageDropdown]="showJumpToPageDropdown"
         [showCurrentPageReport]="showCurrentPageReport"
         [currentPageReportTemplate]="currentPageReportTemplate"
         [resizableColumns]="resizableColumns"
         [columnResizeMode]="columnResizeMode"
         [reorderableColumns]="reorderableColumns"
         [filterDelay]="filterDelay"
         [rowGroupMode]="rowGroupMode"
         [groupRowsBy]="groupRowsBy"
         [expandedRowKeys]="expandedRowGroups"
         [selectionMode]="selectableRows ? selectionMode : null"
         [selection]="selectedRows"
         [sortField]="sortField"
         [sortMode]="sortMode"
         [sortOrder]="sortOrder"
         (selectionChange)="onSelectionChange($event)"
         (onRowSelect)="rowSelect.emit($event)"
         (onRowUnselect)="rowUnselect.emit($event)"
         (onPage)="pageChange.emit($event)"
         (onSort)="onSortInternal($event)"
         (onFilter)="filterChange.emit($event)"
         (onLazyLoad)="lazyLoad.emit($event)"
         (onColResize)="colResize.emit($event)"
         (onColReorder)="colReorder.emit($event)"
         (onHeaderCheckboxToggle)="headerCheckboxToggle.emit($event)"
>
  <ng-template *ngIf="showCaption" pTemplate="caption">
    <div class="flex items-center gap-3 w-full">
    <div *ngIf="captionActionsTemplate" class="flex items-center gap-2 shrink-0">
      <ng-template [ngTemplateOutlet]="captionActionsTemplate" [ngTemplateOutletInjector]="ptInjector"></ng-template>
    </div>
    <div class="flex items-center justify-end gap-3 w-[50%] ml-[auto]">
    <p-button *ngIf="isTableFiltered" icon="pi pi-filter-slash" (click)="clearAllFilters()" severity="danger" size="small" [rounded]="true" [text]="true" class="mr-1" pTooltip="Remove all active filters" />

    <div class="relative px-2 py-0.5 border-l-4 border-l-fq-link m-0 h-[25px]">
      <span class="font-medium whitespace-nowrap text-[15px] align-middle" *ngIf="pt?.value?.length > 0">
      {{getCount(pt)}}</span>
    </div>

    <p-inputgroup class="h-[35px]">
    <ng-container *ngIf="showSearch">
    <p-inputgroup-addon>
        <i class="pi pi-search"></i>
    </p-inputgroup-addon>
    <input pInputText [readonly]="disableAutocomplete" (focus)="disableAutocomplete = false" name="no-autofill" autocomplete="off" type="text" #searchInput (input)="pt.filterGlobal($event.target.value, 'contains'); pt.resetScrollTop()" placeholder="Search" />
    </ng-container>
<p-inputgroup-addon *ngIf="showColumnToggle">
    <p-button *ngIf="showColFilters" icon="pi pi-filter-slash" (click)="toggleColFilters()" severity="secondary" pTooltip="Toggle column filters" tooltipPosition="left"/>
    <p-button *ngIf="!showColFilters" icon="pi pi-filter" (click)="toggleColFilters()" severity="secondary" pTooltip="Toggle column filters" tooltipPosition="left"/>

</p-inputgroup-addon>
<p-inputgroup-addon *ngIf="showOption">
    <p-button icon="pi pi-cog" (click)="showOptions()" severity="secondary" pTooltip="Table settings" tooltipPosition="left"/>
</p-inputgroup-addon>
<p-inputgroup-addon *ngIf="showStats">
    <p-button icon="pi pi-chart-bar" (click)="showTableStats()" severity="secondary" pTooltip="Data analysis" tooltipPosition="left"/>
</p-inputgroup-addon>
<p-inputgroup-addon *ngIf="exportFileName && (exportFormat === 'excel' || exportFormat === 'both')">
    <p-button icon="pi pi-file-excel" (click)="requestExport('excel')" severity="secondary" pTooltip="Export to Excel" tooltipPosition="left"/>
</p-inputgroup-addon>
<p-inputgroup-addon *ngIf="exportFileName && (exportFormat === 'csv' || exportFormat === 'both')">
    <p-button icon="pi pi-download" (click)="requestExport('csv')" severity="secondary" pTooltip="Export to CSV" tooltipPosition="left"/>
</p-inputgroup-addon>
</p-inputgroup>

    </div>
    </div>
  </ng-template>

<ng-template pTemplate="header">
  <tr>
    <ng-container *ngIf="visibleColumns?.length > 0; else projectedHeader">
      <ng-container *ngFor="let col of visibleColumns">
        <th pFrozenColumn [frozen]="col.frozen === true" [pSortableColumn]="col.sortable !== false ? col.field : null"
            [ngClass]="col.headerClass" [style.width]="col.width || null">
        {{ col.header }}
        <ng-container *ngIf="col.sortable !== false">
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </ng-container>
      </th>
      </ng-container>
    </ng-container>
  </tr>
  <tr *ngIf="showColFilters" class="scrollFilterTree" >
                  <ng-container *ngFor="let col of visibleColumns">
                  <th pFrozenColumn [frozen]="col.frozen === true"
                   class="!bg-[#cbd5e1]">
                    <ng-container *ngIf="col.field != 'showField' && col.sortable !== false && col.filterable !== false">
                      <!-- Numeric filter -->
                      <input *ngIf="col.filterType === 'numeric'" class="w-full text-center fq-form-control"
                        [readonly]="disableAutocomplete" (focus)="disableAutocomplete = false" name="no-autofill" autocomplete="off"
                        [placeholder]="col.filterPlaceholder || ''" pInputText type="number"
                        [value]="getFilterValue(col.field) ?? ''"
                        (input)="applyColumnFilter(col, $event.target.value)">
                      <!-- Date filter -->
                      <p-datepicker *ngIf="col.filterType === 'date'" [ngModel]="getDateFilterValue(col.field)"
                        [ngModelOptions]="{ standalone: true }" (onSelect)="applyColumnFilter(col, $event)"
                        (onClear)="clearColumnFilter(col)" [showClear]="true" dateFormat="dd/mm/yy"
                        [placeholder]="col.filterPlaceholder || ''" styleClass="w-full" appendTo="body"></p-datepicker>
                      <!-- Select / boolean filter -->
                      <p-select *ngIf="col.filterType === 'select' || col.filterType === 'boolean'"
                        [options]="getFilterOptions(col)" [ngModel]="getFilterValue(col.field)"
                        [ngModelOptions]="{ standalone: true }" (onChange)="applyColumnFilter(col, $event.value)"
                        optionLabel="label" optionValue="value" [showClear]="true"
                        [placeholder]="col.filterPlaceholder || ''" styleClass="w-full" appendTo="body"></p-select>
                      <!-- Default text filter -->
                      <input *ngIf="!col.filterType || col.filterType === 'text'" class="w-full text-center fq-form-control"
                        [readonly]="disableAutocomplete" (focus)="disableAutocomplete = false" name="no-autofill" autocomplete="off"
                        [placeholder]="col.filterPlaceholder || ''" pInputText
                        [value]="getFilterValue(col.field) ?? ''"
                        type="search" (input)="applyColumnFilter(col, $event.target.value)">
                    </ng-container>
                  </th>
                </ng-container>
                </tr>
</ng-template>

<ng-template #projectedHeader>
  <ng-container *ngIf="headerTemplate">
    <ng-template [ngTemplateOutlet]="headerTemplate" [ngTemplateOutletInjector]="ptInjector"></ng-template>
  </ng-container>
</ng-template>


<ng-template #groupheader let-row let-rowIndex="rowIndex" let-expanded="expanded" *ngIf="groupRowsBy">
        <tr pRowGroupHeader class="font-bold">
            <td [attr.colspan]="visibleColumns.length" class="text-center" >
              <button *ngIf="expandableRows" type="button"
                    pButton
                    pRipple
                    [pRowToggler]="row"
                    text
                    rounded
                    plain
                    class="mr-2 fq-row-group-toggler"
                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                <span class="font-bold ml-2 text-white">{{row[groupRowsBy]}}</span>
            </td>
        </tr>
    </ng-template>

  <ng-template pTemplate="body" let-row let-rowIndex="rowIndex" *ngIf="bodyTemplate && !expandableRows">
    <ng-template [ngTemplateOutlet]="bodyTemplate" [ngTemplateOutletContext]="{$implicit: row, columnsOptions: visibleColumns, isColumnVisible: isColumnVisible.bind(this)}" [ngTemplateOutletInjector]="ptInjector"></ng-template>
  </ng-template>

  <!-- Loader mostrato nel body quando i dati non sono ancora arrivati o renderizzati -->
  <ng-template pTemplate="loadingbody" let-columns let-frozen="frozen">
    <tr *ngIf="!frozen">
      <td [attr.colspan]="visibleColumns.length || 1" class="text-center p-10">
        <p-progressspinner [style]="{ width: '40px', height: '40px' }" strokeWidth="4" />
        <div class="mt-3 text-fq-text-muted text-sm font-medium">{{ loadingMessage }}</div>
      </td>
    </tr>
  </ng-template>

  <!-- Default body template quando non è fornito un bodyTemplate personalizzato -->
  <ng-template pTemplate="body" let-row let-rowIndex="rowIndex" *ngIf="!bodyTemplate && !expandableRows">
    <tr>
      <ng-container *ngFor="let col of visibleColumns">
        <td [ngClass]="col.bodyClass" [style.text-align]="col.align || null">{{ formatCell(row, col) }}</td>
      </ng-container>
    </tr>
  </ng-template>

  <!-- Empty state: sovrascrivibile proiettando un contenuto `#emptymessage` -->
  <ng-template pTemplate="emptymessage">
    @if (emptyTemplate) {
      <ng-template [ngTemplateOutlet]="emptyTemplate" [ngTemplateOutletInjector]="ptInjector"></ng-template>
    } @else {
      <tr>
        <td [attr.colspan]="visibleColumns.length || 1" class="text-center p-6 text-fq-text-muted text-sm">{{ emptyMessage }}</td>
      </tr>
    }
  </ng-template>

    <ng-template pTemplate="expandedrow" let-row *ngIf="bodyTemplate && expandableRows">
    <ng-template [ngTemplateOutlet]="bodyTemplate" [ngTemplateOutletContext]="{$implicit: row, columnsOptions: visibleColumns, isColumnVisible: isColumnVisible.bind(this)}" [ngTemplateOutletInjector]="ptInjector"></ng-template>
  </ng-template>

  <ng-template pTemplate="expandedrow" let-row *ngIf="!bodyTemplate && expandableRows">
    <tr>
      <ng-container *ngFor="let col of visibleColumns">
        <td [ngClass]="col.bodyClass" [style.text-align]="col.align || null">{{ formatCell(row, col) }}</td>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="footer" *ngIf="footerTemplate">
    <ng-template [ngTemplateOutlet]="footerTemplate" [ngTemplateOutletInjector]="ptInjector"></ng-template>
  </ng-template>
</p-table>

<p-dialog [(visible)]="openOptions" [modal]="true" [style]="{ width: '30rem' }" header="Table Settings" [draggable]="false" [resizable]="false">
    <div class="pt-2">
        <div class="flex items-center justify-between gap-3 mb-3">
            <label class="block text-xs font-semibold text-fq-text-muted uppercase tracking-wide">Column Management</label>
            <div class="flex items-center gap-2">
                <span class="text-xs text-fq-text-muted">Density</span>
                <p-select [options]="densityOptions" [(ngModel)]="previewDensity" optionLabel="label" optionValue="value" [style]="{ minWidth: '9rem' }" />
            </div>
        </div>
        @if (columnsCopy) {
        <div class="border border-fq-border rounded-lg overflow-hidden">
            <div class="grid grid-cols-[1.5rem_1fr_3.5rem_3.5rem] gap-2 items-center px-3 py-2 bg-fq-surface-subtle text-xs font-semibold text-fq-text-muted">
                <span></span>
                <span>Column Name</span>
                <span class="text-center">Show</span>
                <span class="text-center">Lock</span>
            </div>
            <div cdkDropList (cdkDropListDropped)="dropColumn($event)" class="max-h-[360px] overflow-auto">
                @for (row of columnsCopy; track row.field) {
                <div cdkDrag class="grid grid-cols-[1.5rem_1fr_3.5rem_3.5rem] gap-2 items-center px-3 py-2 border-t border-fq-border-faint bg-fq-surface">
                    <span cdkDragHandle class="cursor-move text-fq-text-muted flex items-center justify-center" title="Drag to reorder">
                        <i class="pi pi-bars"></i>
                    </span>
                    <span class="text-sm text-fq-text-3 truncate" [title]="row.header">{{row.header || row.field}}</span>
                    <span class="flex justify-center"><p-toggleswitch [(ngModel)]="row.show" styleClass="p-toggleswitch-sm" /></span>
                    <span class="flex justify-center"><p-toggleswitch [(ngModel)]="row.frozen" styleClass="p-toggleswitch-sm" /></span>
                </div>
                }
            </div>
        </div>
        }
    </div>
    <ng-template #footer>
        <p-button label="Reset" [text]="true" severity="danger" (click)="resetOptions()" pTooltip="Reset columns, density and grouping to defaults" />
        <p-button label="Cancel" [text]="true" severity="secondary" (click)="openOptions = false" />
        <p-button label="Apply Changes" [outlined]="true" severity="primary" (click)="openOptions = false; saveOptions()" />
    </ng-template>
</p-dialog>

<!-- Export scope confirmation: shown only when the table is filtered -->
<p-dialog [(visible)]="exportDialogVisible" [modal]="true" [style]="{ width: '30rem' }"
    header="Export data" [draggable]="false" [resizable]="false" styleClass="fq-export-scope-dialog">
    <div class="flex items-start gap-3 pt-1">
        <i class="pi pi-filter text-fq-warning text-2xl mt-0.5"></i>
        <div class="flex flex-col gap-1">
            <span class="text-sm text-fq-text-2">
                The table is currently filtered: <strong>{{ exportFilteredCount }}</strong> of
                <strong>{{ exportTotalCount }}</strong> rows are visible.
            </span>
            <span class="text-sm text-fq-text-muted">Which rows do you want to export?</span>
        </div>
    </div>
    <ng-template #footer>
        <p-button label="Cancel" [text]="true" severity="secondary" (click)="exportDialogVisible = false" />
        <p-button label="All rows ({{ exportTotalCount }})" [outlined]="true" severity="secondary"
            (click)="confirmExportAll()" />
        <p-button label="Filtered only ({{ exportFilteredCount }})" severity="primary"
            (click)="confirmExportFilteredOnly()" />
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="openStats" [modal]="true" [maximizable]="true"
    [style]="{ width: '75vw', 'max-width': '1200px', 'background': 'var(--color-fq-surface-subtle)' }"
    styleClass="stats-dialog">
    <ng-template #header>
        <span class="font-extrabold text-white text-base tracking-wide">Data Analysis</span>
    </ng-template>

    <div class="p-6 min-h-full" *ngIf="tableStatistics">
        <!-- View switcher: Statistical Overview vs Custom Analysis (Pivot) -->
        <div class="mb-5">
            <p-selectButton [options]="statsViewOptions" [(ngModel)]="statsView"
                optionLabel="label" optionValue="value" (onChange)="onStatsViewChange()">
                <ng-template pTemplate="item" let-option>
                    <i class="{{option.icon}} mr-1"></i>{{option.label}}
                </ng-template>
            </p-selectButton>
        </div>

        <!-- ===================== CUSTOM ANALYSIS / PIVOT ===================== -->
        <div *ngIf="statsView === 'pivot'">

            <!-- Mode switcher + data source -->
            <div class="flex flex-wrap items-center gap-4 mb-4">
                <p-selectButton [options]="pivotModeOptions" [(ngModel)]="pivotMode"
                    optionLabel="label" optionValue="value" (onChange)="onPivotChange()">
                    <ng-template pTemplate="item" let-option>
                        <i class="{{option.icon}} mr-1"></i>{{option.label}}
                    </ng-template>
                </p-selectButton>
                <div class="flex items-center gap-2 ml-auto">
                    <p-toggleswitch [(ngModel)]="pivotUseFiltered" (onChange)="onPivotChange()" [disabled]="!pivotHasFilteredRows" />
                    <span class="text-xs" [class.text-fq-text-muted]="!pivotHasFilteredRows">Use filtered rows</span>
                </div>
            </div>

            <!-- Controls card -->
            <div class="bg-fq-surface border border-fq-border rounded-xl p-5 mb-5 shadow-sm">
                <span class="inline-block text-[0.55rem] bg-fq-surface-muted text-fq-text-2 px-1.5 py-0.5 rounded font-bold uppercase mb-3">Pivot Builder</span>

                <!-- Grouped: group-by multi-select -->
                <div *ngIf="pivotMode === 'grouped'" class="mb-4">
                    <label class="block text-xs font-semibold text-fq-text-muted uppercase mb-1.5 tracking-wide">Group rows by (one or more columns)</label>
                    <p-multiselect [options]="pivotGroupByOptions" [(ngModel)]="pivotGroupBy"
                        optionLabel="label" optionValue="value" [showClear]="true" display="chip"
                        placeholder="Choose columns (e.g. Tecnologia, Server)" styleClass="w-full"
                        (onChange)="onPivotChange()" />
                </div>

                <!-- Cross-tab: row / col fields -->
                <div *ngIf="pivotMode === 'crosstab'" class="flex flex-wrap gap-4 mb-4">
                    <div class="flex-1 min-w-[200px]">
                        <label class="block text-xs font-semibold text-fq-text-muted uppercase mb-1.5 tracking-wide">Rows (first dimension)</label>
                        <p-select [options]="pivotGroupByOptions" [(ngModel)]="pivotRowField"
                            optionLabel="label" optionValue="value" [showClear]="true"
                            placeholder="Choose row field" styleClass="w-full" (onChange)="onPivotChange()" />
                    </div>
                    <div class="flex-1 min-w-[200px]">
                        <label class="block text-xs font-semibold text-fq-text-muted uppercase mb-1.5 tracking-wide">Columns (second dimension)</label>
                        <p-select [options]="pivotGroupByOptions" [(ngModel)]="pivotColField"
                            optionLabel="label" optionValue="value" [showClear]="true"
                            placeholder="Choose column field" styleClass="w-full" (onChange)="onPivotChange()" />
                    </div>
                </div>

                <!-- Measures -->
                <div class="flex flex-wrap gap-4 items-end mb-4">
                    <div class="flex-1 min-w-[180px]">
                        <label class="block text-xs font-semibold text-fq-text-muted uppercase mb-1.5 tracking-wide">Value field (optional)</label>
                        <p-select [options]="pivotValueFieldOptions" [(ngModel)]="pivotValueField"
                            optionLabel="label" optionValue="value" [showClear]="true"
                            placeholder="None (just count rows)" styleClass="w-full" (onChange)="onPivotChange()" />
                    </div>
                    <div *ngIf="pivotMode === 'grouped'" class="flex-1 min-w-[220px]">
                        <label class="block text-xs font-semibold text-fq-text-muted uppercase mb-1.5 tracking-wide">Aggregations (one or more)</label>
                        <p-multiselect [options]="pivotAggregationOptions" [(ngModel)]="pivotAggregations"
                            optionLabel="label" optionValue="value" display="chip"
                            placeholder="Count" styleClass="w-full" (onChange)="onPivotChange()" />
                    </div>
                    <div *ngIf="pivotMode === 'crosstab'" class="flex-1 min-w-[160px]">
                        <label class="block text-xs font-semibold text-fq-text-muted uppercase mb-1.5 tracking-wide">Aggregation</label>
                        <p-select [options]="pivotAggregationOptions" [(ngModel)]="pivotCrosstabAgg"
                            optionLabel="label" optionValue="value"
                            [disabled]="!pivotValueField" styleClass="w-full" (onChange)="onPivotChange()" />
                    </div>
                    <div class="flex-1 min-w-[150px]">
                        <label class="block text-xs font-semibold text-fq-text-muted uppercase mb-1.5 tracking-wide">Date grouping</label>
                        <p-select [options]="pivotDateBucketOptions" [(ngModel)]="pivotDateBucket"
                            optionLabel="label" optionValue="value" styleClass="w-full" (onChange)="onPivotChange()" />
                    </div>
                    <div class="flex-1 min-w-[140px]">
                        <label class="block text-xs font-semibold text-fq-text-muted uppercase mb-1.5 tracking-wide">Numeric interval</label>
                        <input pInputText type="number" [ngModel]="pivotNumericInterval"
                            (ngModelChange)="pivotNumericInterval = $event; onPivotChange()"
                            placeholder="e.g. 10" styleClass="w-full" />
                    </div>
                </div>

                <!-- Grouped: having + sorting -->
                <div *ngIf="pivotMode === 'grouped'" class="flex flex-wrap gap-4 items-end mb-4">
                    <div class="flex items-end gap-2 min-w-[260px]">
                        <div class="w-[6.5rem]">
                            <label class="block text-xs font-semibold text-fq-text-muted uppercase mb-1.5 tracking-wide">Having</label>
                            <p-select [options]="pivotHavingOptions" [(ngModel)]="pivotHavingOperator"
                                optionLabel="label" optionValue="value" styleClass="w-full" (onChange)="onPivotChange()" />
                        </div>
                        <div class="flex-1 min-w-[80px]">
                            <label class="block text-xs font-semibold text-fq-text-muted uppercase mb-1.5 tracking-wide">Value</label>
                            <input pInputText type="number" [ngModel]="pivotMinValue"
                                (ngModelChange)="pivotMinValue = $event; onPivotChange()" placeholder="min" styleClass="w-full" />
                        </div>
                        <div *ngIf="pivotHavingOperator === 'between'" class="flex-1 min-w-[80px]">
                            <label class="block text-xs font-semibold text-fq-text-muted uppercase mb-1.5 tracking-wide">Max</label>
                            <input pInputText type="number" [ngModel]="pivotMaxValue"
                                (ngModelChange)="pivotMaxValue = $event; onPivotChange()" placeholder="max" styleClass="w-full" />
                        </div>
                    </div>
                    <div class="w-[9rem]">
                        <label class="block text-xs font-semibold text-fq-text-muted uppercase mb-1.5 tracking-wide">Sort by</label>
                        <p-select [options]="pivotSortOptions" [(ngModel)]="pivotSortBy"
                            optionLabel="label" optionValue="value" styleClass="w-full" (onChange)="onPivotChange()" />
                    </div>
                    <div class="w-[9rem]">
                        <label class="block text-xs font-semibold text-fq-text-muted uppercase mb-1.5 tracking-wide">Order</label>
                        <p-select [options]="pivotSortOrderOptions" [(ngModel)]="pivotSortOrder"
                            optionLabel="label" optionValue="value" styleClass="w-full" (onChange)="onPivotChange()" />
                    </div>
                </div>

                <!-- Cross-tab: measure + top columns + sorting -->
                <div *ngIf="pivotMode === 'crosstab'" class="flex flex-wrap gap-4 items-end mb-4">
                    <div class="w-[10rem]">
                        <label class="block text-xs font-semibold text-fq-text-muted uppercase mb-1.5 tracking-wide">Display measure</label>
                        <p-select [options]="pivotMeasureOptions" [(ngModel)]="pivotMeasure"
                            optionLabel="label" optionValue="value" styleClass="w-full" (onChange)="onPivotChange()" />
                    </div>
                    <div class="w-[9rem]">
                        <label class="block text-xs font-semibold text-fq-text-muted uppercase mb-1.5 tracking-wide">Top columns</label>
                        <input pInputText type="number" [ngModel]="pivotTopColumns"
                            (ngModelChange)="pivotTopColumns = $event; onPivotChange()" placeholder="e.g. 30" styleClass="w-full" />
                    </div>
                    <div class="flex items-center gap-2 pb-2">
                        <p-toggleswitch [(ngModel)]="pivotGroupOthers" (onChange)="onPivotChange()" />
                        <span class="text-xs text-fq-text-muted">Group others</span>
                    </div>
                    <div class="w-[9rem]">
                        <label class="block text-xs font-semibold text-fq-text-muted uppercase mb-1.5 tracking-wide">Sort rows by</label>
                        <p-select [options]="pivotSortOptions" [(ngModel)]="pivotSortBy"
                            optionLabel="label" optionValue="value" styleClass="w-full" (onChange)="onPivotChange()" />
                    </div>
                    <div class="w-[9rem]">
                        <label class="block text-xs font-semibold text-fq-text-muted uppercase mb-1.5 tracking-wide">Order</label>
                        <p-select [options]="pivotSortOrderOptions" [(ngModel)]="pivotSortOrder"
                            optionLabel="label" optionValue="value" styleClass="w-full" (onChange)="onPivotChange()" />
                    </div>
                </div>

                <!-- Options + active filters -->
                <div class="flex flex-wrap items-center gap-5 mb-4">
                    <div class="flex items-center gap-2">
                        <p-toggleswitch [(ngModel)]="pivotCompactNumbers" (onChange)="onPivotChange()" />
                        <span class="text-xs text-fq-text-muted">Compact numbers</span>
                    </div>
                    <div class="flex items-center gap-2">
                        <p-toggleswitch [(ngModel)]="pivotDrillDownKeepOpen" />
                        <span class="text-xs text-fq-text-muted">Keep dialog open on drill-down</span>
                    </div>
                    <div *ngIf="pivotAppliedFilters.length" class="flex flex-wrap items-center gap-2 ml-auto">
                        <i class="pi pi-filter text-fq-warning"></i>
                        <span *ngFor="let f of pivotAppliedFilters" class="text-[0.7rem] bg-fq-surface-muted text-fq-text-2 px-2 py-0.5 rounded">
                            {{ headerOf(f.field) }}: {{ f.value }}
                        </span>
                        <p-button icon="pi pi-filter-slash" severity="danger" [text]="true" [rounded]="true" pTooltip="Clear analysis filters" (click)="clearAnalysisFilters()" />
                    </div>
                </div>

                <!-- Actions -->
                <div class="flex gap-2 flex-wrap items-center">
                    <p-button label="Analyze" icon="pi pi-chart-bar" (click)="computePivot()" [loading]="pivotLoading" />
                    <p-button label="Reset" icon="pi pi-eraser" [outlined]="true" severity="secondary" (click)="resetPivot()" />
                    <p-button label="Export Excel" icon="pi pi-file-excel" [outlined]="true" severity="secondary" (click)="exportPivot()" [disabled]="!hasPivotResult()" />
                    <p-button label="Export CSV" icon="pi pi-download" [outlined]="true" severity="secondary" (click)="exportPivotCsv()" [disabled]="!hasPivotResult()" />
                    <p-button [label]="pivotShowChart ? 'Hide chart' : 'Show chart'" [icon]="pivotShowChart ? 'pi pi-eye-slash' : 'pi pi-chart-line'" [outlined]="true" severity="secondary" (click)="togglePivotChart()" [disabled]="!hasPivotResult()" />
                </div>
            </div>

            <!-- Chart -->
            <div *ngIf="pivotShowChart" class="bg-fq-surface border border-fq-border rounded-xl p-4 mb-5">
                <div class="flex flex-wrap items-center gap-3 mb-3">
                    <span class="text-xs font-semibold text-fq-text-muted uppercase tracking-wide mr-auto">Chart</span>
                    <p-select [options]="pivotChartTypeOptions" [(ngModel)]="pivotChartType"
                        optionLabel="label" optionValue="value" (onChange)="onPivotChange()" styleClass="min-w-[7rem]" />
                    <div class="flex items-center gap-1">
                        <label class="text-xs text-fq-text-muted">Top</label>
                        <input pInputText type="number" class="w-[4.5rem]" [ngModel]="pivotChartTopN"
                            (ngModelChange)="pivotChartTopN = $event; onPivotChange()" />
                    </div>
                    <div class="flex items-center gap-1"><p-toggleswitch [(ngModel)]="pivotChartLogScale" (onChange)="onPivotChange()" /><span class="text-xs text-fq-text-muted">Log</span></div>
                    <div class="flex items-center gap-1"><p-toggleswitch [(ngModel)]="pivotChartDataLabels" (onChange)="onPivotChange()" /><span class="text-xs text-fq-text-muted">Labels</span></div>
                    <div *ngIf="pivotMode === 'grouped'" class="flex items-center gap-1"><p-toggleswitch [(ngModel)]="pivotChartPercent" (onChange)="onPivotChange()" /><span class="text-xs text-fq-text-muted">%</span></div>
                    <p-button icon="pi pi-image" [outlined]="true" severity="secondary" pTooltip="Download chart as PNG" (click)="exportPivotChartPng()" />
                </div>
                <div #pivotChart class="w-full h-[420px]"></div>
            </div>

            <!-- Loading -->
            <div *ngIf="pivotLoading" class="flex items-center justify-center gap-3 py-6 text-fq-text-muted text-sm">
                <p-progressspinner [style]="{ width: '28px', height: '28px' }" strokeWidth="4"></p-progressspinner>
                Computing analysis...
            </div>

            <!-- =============== GROUPED RESULT =============== -->
            <div *ngIf="pivotMode === 'grouped'">
                <div *ngIf="pivotGroupBy && pivotGroupBy.length > 0">
                    <div *ngIf="pivotResult.length > 0; else noPivot">
                        <div class="flex flex-wrap items-center gap-3 mb-2">
                            <p class="text-sm text-fq-text-muted m-0">
                                <i class="pi pi-info-circle"></i> Click a leaf row to drill-down. Grand total: <strong>{{ formatPivotValue(pivotGrandTotals[0]) }}</strong>.
                            </p>
                            <p-button label="Expand all" [text]="true" size="small" (click)="expandAllPivotNodes()" />
                            <p-button label="Collapse all" [text]="true" size="small" (click)="collapseAllPivotNodes()" />
                        </div>
                        <p *ngIf="pivotIsFiltered" class="text-xs text-fq-warning m-0 mb-1">
                            <i class="pi pi-filter"></i> Analyzing <strong>{{ pivotSourceCount }}</strong> filtered rows of {{ exportTotalCount }}.
                        </p>
                        <p-table [value]="pivotResult" [scrollable]="true" scrollHeight="50vh"
                            styleClass="p-datatable-sm" [paginator]="pivotResult.length > 15" [rows]="15">
                            <ng-template pTemplate="header">
                                <tr class="bg-fq-surface-subtle">
                                    <th *ngFor="let col of pivotColumns" class="text-center text-xs text-fq-text-2 whitespace-nowrap">{{col.header}}</th>
                                    <th *ngIf="pivotShowPercentage" class="text-center text-xs text-fq-text-2 whitespace-nowrap">% of total</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-row>
                                <tr [class.cursor-pointer]="!row.__hasChildren" [attr.title]="row.__hasChildren ? null : 'Drill-down to these rows'"
                                    (click)="!row.__hasChildren && drillDownPivot(row)">
                                    <td *ngFor="let col of pivotColumns; let c = index"
                                        class="text-sm text-fq-text-3"
                                        [ngClass]="(c === 0 && pivotGroupCount > 1) ? 'text-left' : 'text-center'">
                                        <ng-container *ngIf="c < pivotGroupCount">
                                            <span *ngIf="c === 0" class="inline-flex items-center" [style.padding-left.px]="row.__level * 18">
                                                <button *ngIf="row.__hasChildren" type="button" pButton pRipple
                                                    text rounded plain class="fq-row-group-toggler mr-1"
                                                    [icon]="row.__expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                                                    (click)="$event.stopPropagation(); togglePivotNode(row)"></button>
                                                <span [class.font-semibold]="row.__hasChildren">{{ row.__groups[c] }}</span>
                                            </span>
                                            <span *ngIf="c !== 0">{{ row.__groups[c] }}</span>
                                        </ng-container>
                                        <span *ngIf="c >= pivotGroupCount" class="font-bold text-fq-info">{{ formatPivotValue(row.__values[c - pivotGroupCount]) }}</span>
                                    </td>
                                    <td *ngIf="pivotShowPercentage" class="text-center text-sm text-fq-text-3 font-semibold">
                                        {{ formatPivotPercent(row.__values[0], pivotGrandTotals[0]) }}
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                    <ng-template #noPivot>
                        <div class="text-center p-8 text-fq-text-muted text-sm">
                            No combinations match the current selection.
                        </div>
                    </ng-template>
                </div>
                <div *ngIf="!pivotGroupBy || pivotGroupBy.length === 0" class="text-center p-8 text-fq-text-muted text-sm">
                    Select at least one column to group by (e.g. <strong>Tecnologia</strong> and <strong>Server</strong>) to build your custom analysis.
                </div>
            </div>

            <!-- =============== CROSS-TAB RESULT =============== -->
            <div *ngIf="pivotMode === 'crosstab'">
                <div *ngIf="pivotRowField && pivotColField">
                    <div *ngIf="pivotCrossTab; else noCross">
                        <p *ngIf="pivotIsFiltered" class="text-xs text-fq-warning m-0 mb-1">
                            <i class="pi pi-filter"></i> Analyzing <strong>{{ pivotSourceCount }}</strong> filtered rows of {{ exportTotalCount }}.
                        </p>
                        <p *ngIf="pivotTruncatedColumns > 0" class="text-xs text-fq-warning m-0 mb-1">
                            <i class="pi pi-exclamation-triangle"></i>
                            {{ pivotTruncatedColumns }} less frequent columns {{ pivotCrossTab.hasOthers ? 'grouped as \"Others\"' : 'hidden' }}.
                        </p>
                        <p class="text-sm text-fq-text-muted m-0 mb-2">
                            <i class="pi pi-info-circle"></i> Click a cell to drill-down. Grand total: <strong>{{ formatPivotValue(pivotCrossTab.grandTotal) }}</strong>.
                            <span *ngIf="pivotMeasure !== 'value'"> Percentages are computed on {{ pivotMeasure === 'rowPct' ? 'the row total' : pivotMeasure === 'colPct' ? 'the column total' : 'the grand total' }}.</span>
                        </p>
                        <p-table [value]="pivotCrossTab.rowFields" [scrollable]="true" scrollHeight="50vh"
                            styleClass="p-datatable-sm" [paginator]="pivotCrossTab.rowFields.length > 15" [rows]="15">
                            <ng-template pTemplate="header">
                                <tr class="bg-fq-surface-subtle">
                                    <th class="text-center text-xs text-fq-text-2 whitespace-nowrap">{{ headerOf(pivotRowField) }}</th>
                                    <th *ngFor="let cf of pivotCrossTab.colFields" class="text-center text-xs text-fq-text-2 whitespace-nowrap">{{cf}}</th>
                                    <th class="text-center text-xs text-fq-text-2 whitespace-nowrap">Total</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-row let-ri="rowIndex">
                                <tr>
                                    <td class="text-center font-semibold text-fq-text-3">{{row}}</td>
                                    <td *ngFor="let cf of pivotCrossTab.colFields; let ci = index"
                                        class="text-center text-sm text-fq-text-3 cursor-pointer" (click)="drillDownCrossTab(row, cf)" title="Drill-down to this cell">
                                        {{ crossTabCellDisplay(ri, ci) }}
                                    </td>
                                    <td class="text-center text-sm font-bold text-fq-info">{{ formatPivotValue(pivotCrossTab.rowTotals[ri]) }}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="footer">
                                <tr>
                                    <td class="text-center font-bold text-fq-text-2">Total</td>
                                    <td *ngFor="let cf of pivotCrossTab.colFields; let ci = index" class="text-center font-bold text-fq-info">{{ formatPivotValue(pivotCrossTab.colTotals[ci]) }}</td>
                                    <td class="text-center font-bold text-fq-info">{{ formatPivotValue(pivotCrossTab.grandTotal) }}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                    <ng-template #noCross>
                        <div class="text-center p-8 text-fq-text-muted text-sm">
                            Pick a row and a column field to build the cross-tab matrix.
                        </div>
                    </ng-template>
                </div>
                <div *ngIf="!pivotRowField || !pivotColField" class="text-center p-8 text-fq-text-muted text-sm">
                    Choose a <strong>Rows</strong> field and a <strong>Columns</strong> field to build a cross-tab matrix.
                </div>
            </div>
        </div>

        <!-- ===================== STATISTICAL OVERVIEW ===================== -->
        <div *ngIf="statsView === 'overview'">
        <!-- Snapshot-style information bar with gradient -->
        <div class="bg-gradient-to-r from-[#334155] to-[#19549f] py-2.5 px-6 rounded-lg mb-6 flex items-center text-white shadow-md border border-white/5">
            <div class="flex items-center gap-10">
                <div>
                    <span class="block text-[0.7rem] text-fq-text-muted font-bold uppercase tracking-widest">Structure</span>
                    <span class="text-sm font-bold">{{columns.length}} <span class="text-fq-text-muted font-normal text-[0.7rem]">columns</span></span>
                </div>
                <div class="text-white text-sm font-bold">/</div>
                <div>
                    <span class="block text-[0.7rem] text-fq-text-muted font-bold uppercase tracking-widest">Dataset Size</span>
                    <span class="text-sm font-bold">{{tableStatistics.totalRows}} <span class="text-fq-text-muted font-normal text-[0.7rem]">rows</span></span>
                </div>
            </div>
        </div>

        <!-- Cards Grid -->
        <div class="flex flex-wrap gap-5 justify-start">
            <div *ngFor="let col of columns" class="flex-[0_0_calc(33.333%-0.85rem)] min-w-[320px] bg-fq-surface border border-fq-border rounded-xl p-5 shadow-sm flex flex-col gap-4">

                <!-- Card Header -->
                <div class="flex justify-between items-start">
                    <div class="overflow-hidden flex-1">
                        <span class="text-[0.55rem] bg-fq-surface-muted text-fq-text-2 px-1.5 py-0.5 rounded font-bold uppercase mb-1 inline-block">{{tableStatistics.columns[col.field].type}}</span>
                        <span class="block font-bold text-fq-text text-sm whitespace-nowrap overflow-hidden text-ellipsis" [title]="col.header">{{col.header}}</span>
                    </div>
                    <div class="bg-fq-surface-muted border border-fq-border-soft px-2.5 py-1 rounded-lg text-center">
                        <span class="block text-sm font-bold text-fq-info leading-none">{{tableStatistics.columns[col.field].uniqueCount}}</span>
                        <span class="text-[0.5rem] text-fq-info font-semibold uppercase">Unique</span>
                    </div>
                </div>

                <!-- Data Quality Box -->
                <div class="bg-fq-surface-subtle border border-fq-border-faint rounded-lg px-3 py-2.5 flex items-center justify-between">
                    <span class="text-sm font-semibold text-fq-text-3">{{ (100 - tableStatistics.columns[col.field].nullPercentage) | number:'1.2-2' }}% Filled</span>
                    <div class="w-[50px] h-[5px] bg-fq-surface-muted rounded-sm overflow-hidden">
                        <div class="h-full bg-fq-primary" [style.width.%]="100 - tableStatistics.columns[col.field].nullPercentage"></div>
                    </div>
                </div>

                <!-- Statistics (Conditional for Number vs Date) -->
                <div class="grid grid-cols-2 gap-3">
                    <!-- Number Case -->
                    <ng-container *ngIf="tableStatistics.columns[col.field].type === 'number'">
                        <div class="border-l-2 border-l-fq-primary pl-2.5">
                            <span class="block text-[0.55rem] text-fq-text-muted font-bold uppercase">Average</span>
                            <span class="text-sm font-bold text-fq-text">{{ tableStatistics.columns[col.field].avg | number:'1.2-2' }}</span>
                        </div>
                        <div class="border-l-2 border-l-fq-border pl-2.5">
                            <span class="block text-[0.55rem] text-fq-text-muted font-bold uppercase">Range</span>
                            <span class="text-sm font-semibold text-fq-text-2">{{tableStatistics.columns[col.field].min}} - {{tableStatistics.columns[col.field].max}}</span>
                        </div>
                    </ng-container>

                    <!-- Date/Timestamp Case -->
                    <ng-container *ngIf="tableStatistics.columns[col.field].type === 'date' || tableStatistics.columns[col.field].type === 'timestamp'">
                        <div class="border-l-2 border-l-fq-success pl-2.5">
                            <span class="block text-[0.55rem] text-fq-text-muted font-bold uppercase">Min Date</span>
                            <span class="text-sm font-semibold text-fq-text whitespace-nowrap overflow-hidden text-ellipsis block" [title]="tableStatistics.columns[col.field].min">{{ tableStatistics.columns[col.field].min }}</span>
                        </div>
                        <div class="border-l-2 border-l-fq-danger pl-2.5">
                            <span class="block text-[0.55rem] text-fq-text-muted font-bold uppercase">Max Date</span>
                            <span class="text-sm font-semibold text-fq-text whitespace-nowrap overflow-hidden text-ellipsis block" [title]="tableStatistics.columns[col.field].max">{{ tableStatistics.columns[col.field].max }}</span>
                        </div>
                    </ng-container>
                </div>

                <!-- Distributions -->
                <div *ngIf="tableStatistics.columns[col.field].topValues?.length" class="mt-1">
                    <div class="flex flex-col gap-2">
                        <div *ngFor="let topVal of tableStatistics.columns[col.field].topValues.slice(0, 3)" class="flex items-center justify-between text-[0.7rem]">
                            <span class="whitespace-nowrap overflow-hidden text-ellipsis max-w-[65%] text-fq-text-2" [title]="topVal.value || '(null)'">{{topVal.value || '(null)'}}</span>
                            <div class="flex items-center gap-2 shrink-0">
                                <span class="font-bold text-fq-text">{{ topVal.percentage | number:'1.1-1' }}%</span>
                                <div class="w-[35px] h-[3px] bg-fq-surface-muted rounded-sm">
                                    <div class="h-full bg-fq-primary/60" [style.width.%]="topVal.percentage"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>

    <ng-template #footer>
        <p-button label="Close" icon="pi pi-times" [outlined]="true" severity="secondary" (click)="openStats = false" size="small" />
    </ng-template>
</p-dialog>
